import settings from '@/settings'

let empresaComProposta = (headers, data) => {
  return fetch(`${settings.apetrusApi}/empresas/comproposta/${data.cnpjPosto}/${data.id_rede ? `?id_rede=${data.id_rede}` : ''}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let PegarBloqueio = (headers, data) => {
  return fetch(`${settings.apetrusApi}/empresas/bloqueio/?posto=${data.posto}&empresa=${data.empresa}${data.rede ? `&rede=${data.rede}` : ''}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let Bloqueio = (headers, data) => {
  // Cadastrar bloqueio e deletar bloqueio
  return fetch(`${settings.apetrusApi}/empresas/bloqueio/`, {
    method: data.id ? 'DELETE' : 'POST',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

let getEmpresasAtivas = (headers, filtros) => {
  let url = `${settings.apetrusApi}/empresas/todasAtivas/?`
  Object.keys(filtros).forEach((filter) => {
    url = `${url}&${filter}=${filtros[filter]}`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  empresaComProposta,
  PegarBloqueio,
  Bloqueio,
  getEmpresasAtivas
}
